<template>
    <b-toast id="toast-voucher" variant="light" auto-hide-delay="30000">
        <h1> &#127903; </h1>
        <h4 class="font-weight-bolder">
            {{ toastTitle ? toastTitle : $t('toast_voucher.title') }}
        </h4>
        <p>
            {{ toastText ? toastText : $t('toast_voucher.text') }}
        </p>
        <div class="d-flex mt-2 justify-content-center">
            <b-button variant="dark" size="sm" @click="hide">
                {{ $t('toast_voucher.btn_cancel') }}
            </b-button>
            <b-button variant="primary" class="ml-2" size="sm" @click="openModalVoucher">
                {{ $t('toast_voucher.btn_next') }}
            </b-button>
        </div>
    </b-toast>
</template>


<script>
    export default {
        props: {
            toastTitle: { type: String, required: false },
            toastText: { type: String, required: false }
        },
        data() {
            return {
                code: '',
                isInvalid: false
            }
        },

        methods: {
            hide() {
                this.isInvalid = false
                this.$bvToast.hide('toast-voucher')
            },

            openModalVoucher() {
                this.$bvToast.hide('toast-voucher')
                this.$bvModal.show('modal-voucher')
            }
        }
    }
</script>
